<template>
  <div class="notification-element">
    <div class="notification-header">
      <span class="notification-type-badge">
        <i class="fas fa-bell"></i>
        <span>Notification</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <i class="fas fa-copy"></i>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
    
    <div class="notification-content" @click="$emit('edit')">
      <div class="notification-recipient">
        <span class="recipient-label">Destinataire:</span>
        <span class="recipient-value">{{ element.to || 'Non défini' }}</span>
      </div>
      
      <div class="notification-type">
        <span class="type-label">Type:</span>
        <span class="type-value">{{ notificationType }}</span>
      </div>
      
      <div class="notification-message">
        <span class="message-label">Message:</span>
        <p class="message-value">{{ notificationMessage }}</p>
      </div>
      
      <div class="notification-preview" v-if="hasPreviewUrl">
        <span class="preview-label">Aperçu URL:</span>
        <span class="preview-value">Activé</span>
      </div>
      
      <div class="edit-button">
        <i class="fas fa-pencil-alt"></i>
        <span>Modifier</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationElement',
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    notificationType() {
      if (this.element.notification && this.element.notification.type) {
        return this.element.notification.type;
      }
      return 'text';
    },
    notificationMessage() {
      if (this.element.notification && this.element.notification.message) {
        return this.element.notification.message;
      }
      return 'Aucun message';
    },
    hasPreviewUrl() {
      return this.element.notification && this.element.notification.preview_url === true;
    }
  }
}
</script>

<style scoped>
.notification-element {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #fcd34d;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.notification-element:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid #fcd34d;
}

.notification-type-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #b45309;
}

.notification-type-badge i {
  color: #d97706;
}

.element-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  background: white;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 28px;
  height: 28px;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.action-btn.delete-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.notification-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  cursor: pointer;
}

.notification-recipient, .notification-type, .notification-preview {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.recipient-label, .type-label, .message-label, .preview-label {
  font-weight: 600;
  color: #92400e;
  font-size: 0.85rem;
  min-width: 100px;
}

.recipient-value, .type-value, .preview-value {
  background: white;
  color: #b45309;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
  border: 1px solid #fcd34d;
}

.notification-message {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message-value {
  background: white;
  color: #92400e;
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
  margin: 0;
  border: 1px solid #fcd34d;
  min-height: 60px;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: white;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  color: #d97706;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  align-self: flex-end;
  margin-top: 0.5rem;
}

.edit-button:hover {
  background: #fef3c7;
  color: #b45309;
  border-color: #fbbf24;
}
</style>
